const adminSelector = ({ admin }) => admin;

export default adminSelector;
